/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CaucaoCriteriaDto } from '../models/caucao-criteria-dto';
import { CaucaoDto } from '../models/caucao-dto';
import { CaucaoPageDto } from '../models/caucao-page-dto';
import { CreateCaucaoFormDto } from '../models/create-caucao-form-dto';


/**
 * Cauções
 */
@Injectable({
  providedIn: 'root',
})
export class CaucoesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCaucoes
   */
  static readonly GetCaucoesPath = '/caucoes';

  /**
   * Pesquisar cauções.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCaucoes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCaucoes$Response(params?: {
    criteria?: CaucaoCriteriaDto;
  }): Observable<StrictHttpResponse<CaucaoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, CaucoesService.GetCaucoesPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CaucaoPageDto>;
      })
    );
  }

  /**
   * Pesquisar cauções.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCaucoes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCaucoes(params?: {
    criteria?: CaucaoCriteriaDto;
  }): Observable<CaucaoPageDto> {

    return this.getCaucoes$Response(params).pipe(
      map((r: StrictHttpResponse<CaucaoPageDto>) => r.body as CaucaoPageDto)
    );
  }

  /**
   * Path part for operation createCaucao
   */
  static readonly CreateCaucaoPath = '/caucoes';

  /**
   * Criar caução.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCaucao()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createCaucao$Response(params?: {
    body?: {
'caucaoForm'?: CreateCaucaoFormDto;
'comprovativoPrestacaoCaucao'?: Blob;
}
  }): Observable<StrictHttpResponse<CaucaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, CaucoesService.CreateCaucaoPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CaucaoDto>;
      })
    );
  }

  /**
   * Criar caução.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createCaucao$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createCaucao(params?: {
    body?: {
'caucaoForm'?: CreateCaucaoFormDto;
'comprovativoPrestacaoCaucao'?: Blob;
}
  }): Observable<CaucaoDto> {

    return this.createCaucao$Response(params).pipe(
      map((r: StrictHttpResponse<CaucaoDto>) => r.body as CaucaoDto)
    );
  }

  /**
   * Path part for operation getCaucao
   */
  static readonly GetCaucaoPath = '/caucoes/{id}';

  /**
   * Detalhe da caução.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCaucao()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCaucao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<CaucaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, CaucoesService.GetCaucaoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CaucaoDto>;
      })
    );
  }

  /**
   * Detalhe da caução.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCaucao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCaucao(params: {
    id: number;
  }): Observable<CaucaoDto> {

    return this.getCaucao$Response(params).pipe(
      map((r: StrictHttpResponse<CaucaoDto>) => r.body as CaucaoDto)
    );
  }

}
